module.exports = __webpack_public_path__ + "static/media/trailz-nav.cb71f5e3.png";